const TOKEN_KEY = 'token';
const TYPE_KEY = 'type';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUserType() {
  return localStorage.getItem(TYPE_KEY);
}

export function hasSession() {
  return Boolean(getToken());
}

export function setSession({ token, userType }) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  if (userType) {
    localStorage.setItem(TYPE_KEY, userType);
  }
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TYPE_KEY);
}
